import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { TrailerType } from '../../../reference-data.api';

interface BuildTrailerTypeColumnsArgs {
  onEdit: (row: TrailerType) => void;
  onDeactivate: (row: TrailerType) => Promise<void>;
  onReactivate: (row: TrailerType) => Promise<void>;
}

export function buildTrailerTypeColumns({ onEdit, onDeactivate, onReactivate }: BuildTrailerTypeColumnsArgs): TableColumnsType<TrailerType> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
